import { Section, Eyebrow, ChromeHeading, Card, Diamond } from "../funnel";

const PILLARS = [
  ["EDUCATE", "The skill set", ["Read a credit report the way an underwriter does", "Clean up the file in the right order", "Sequence applications so one approval doesn't cost you the next", "Build business credit that stands on its own"]],
  ["EQUIP", "The tool set", ["Dispute templates and the clean-up tracker", "Lender and bureau map", "J11 credit software / AI report grader access", "Client intake, agreement and fee sheet, for anyone adding a service"]],
  ["ELEVATE", "Mindset and accountability", ["Weekly live calls where we audit your profile", "One-on-one strategy sessions", "Someone holding you to the plan until it's done"]],
];

const WEEK = [["Mon", "Live profile audits: bring your file"], ["Wed", "Funding strategy call"], ["Fri", "Mindset and wins call"]];

export const Mentorship = () => (
  <Section data-testid="mentorship-section">
    <Eyebrow>INSIDE THE MENTORSHIP</Eyebrow>
    <ChromeHeading className="mt-4 text-4xl sm:text-5xl lg:text-6xl">Educate. Equip. Elevate.</ChromeHeading>
    <div className="mt-12 grid gap-5 lg:grid-cols-3">
      {PILLARS.map(([name, sub, items]) => (
        <Card key={name} hover className="p-7 sm:p-8" data-testid={`pillar-${name.toLowerCase()}`}>
          <p className="font-display gold-text text-5xl leading-none">{name}</p>
          <p className="font-serif-it mt-3 text-xl text-[#efe6d1]">{sub}</p>
          <div className="my-6 hairline" aria-hidden="true" />
          <ul className="space-y-4">
            {items.map((it) => (
              <li key={it} className="flex items-start gap-3 text-[15px] leading-relaxed text-[#e4dccb]">
                <Diamond className="mt-[3px] text-[10px]" />
                <span>{it}</span>
              </li>
            ))}
          </ul>
        </Card>
      ))}
    </div>
  </Section>
);

export const Week = () => (
  <Section data-testid="week-section">
    <div className="grid items-center gap-12 lg:grid-cols-[minmax(0,7fr)_minmax(0,5fr)] lg:gap-16">
      <div>
        <Eyebrow>WHAT A WEEK LOOKS LIKE</Eyebrow>
        <ChromeHeading className="mt-4 text-4xl sm:text-5xl lg:text-6xl">Show me your circle, and I'll show you your future.</ChromeHeading>
        <ul className="mt-10 divide-y divide-[rgba(232,184,74,0.2)] border-y border-[rgba(232,184,74,0.2)]" data-testid="week-schedule">
          {WEEK.map(([day, label]) => (
            <li key={day} className="flex items-center gap-6 py-6" data-testid={`week-${day.toLowerCase()}`}>
              <span className="font-display gold-text w-20 shrink-0 text-5xl leading-none">{day}</span>
              <span className="text-lg font-medium text-[#f1e9d8]">{label}</span>
            </li>
          ))}
        </ul>
      </div>
      <figure className="mx-auto w-full max-w-[340px]" data-testid="week-circle-video-figure">
        <video src="/assets/circle-bw-video.mp4" poster="/assets/circle-bw-video-poster.jpg" controls playsInline preload="metadata" className="block aspect-[9/16] w-full rounded-xl border border-[var(--gold)] bg-black object-cover shadow-[0_0_44px_-10px_rgba(232,184,74,0.45)]" aria-label="From Jay's circle" data-testid="week-circle-video" />
        <figcaption className="font-mono-plex mt-4 text-[12px] tracking-[0.06em] text-[#cfc6b3]" data-testid="week-circle-caption">From Jay's circle · on what he's learned being around him</figcaption>
      </figure>
    </div>
  </Section>
);
